import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate  } from "react-router-dom";
import Home from "../Home";
import Breadcrumb from "../../components/Breadcrumb";
import UltmarcRemarkLabel from "../../components/UltmarcRemarkLabel";
import { Steps, Button, Select } from "antd";
import { Modal, Spinner } from "react-bootstrap";
import {
  getPersonCustomerDetails,
  getAffiliationDetails,
  addAffiliation,
  deleteAffiliation,
  affiliationAttributeChange,
  fetchPersonDetails,
} from "./actions";
import { getOrganizationInquiryList } from "../OrganizationCustomer/actions";
import {
  customerRequestDetails,
  resubmitChangeRequest,
  editChangeRequest,
} from "../CustomerRequestStatus/actions";
import Maintenance from "../Maintenance";

const { Step } = Steps;

/*** 
@purpose : Functional component
@Parameter : {props}
**/
function AffiliationAttributeChange(props) {
  const navigate = useNavigate();
  const [lang] = useTranslation("language");
  const [activeEmployeeSearch, setActiveEmployeeSearch] =
    useState("esearch-box lg-box");
  const [current, setCurrent] = useState(0);
  const [submissionType, setSubmissionType] = useState("");
  const [path, setPath] = useState("");
  const [alreday, setAlreday] = useState(false);
  const [errors, setErrors] = useState({});
  const [customerErrors, setCustomerErrors] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isOrgLoading, setIsOrgLoading] = useState(false);
  const [affiliationNotice, setAffiliationNotice] = useState("");
  const [submissionId, setSubmissionId] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [customerTypeId, setCustomerTypeId] = useState("");
  const [affiliationId, setAffiliationId] = useState("");
  const [customerTypeName, setCustomerTypeName] = useState("");
  const [kanjiFacilityName, setKanjiFacilityName] = useState("");
  const [kanjiCustomerName, setKanjiCustomerName] = useState("");
  const [kanaCustomerName, setKanaCustomerName] = useState("");
  const [unifiedCustomerCode, setUnifiedCustomerCode] = useState("");
  const [legacyUnifiedCustomerCode, setLegacyUnifiedCustomerCode] =
    useState("");
  const [orgUnifiedCustomerCode, setOrgUnifiedCustomerCode] = useState("");
  const [personId, setPersonId] = useState("");
  const [maintenance, setMaintenance] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [role, setRole] = useState("");
  const [hospitalStatus, setHospitalStatus] = useState(0);
  const [departmentId, setDepartmentId] = useState("");
  const [departmentName, setDepartmentName] = useState("");
  const [roleId, setRoleId] = useState("");
  const [roleName, setRoleName] = useState("");
  const [affiliatedOrgId, setAffiliatedOrgId] = useState("");
  const [universityRoleId, setUniversityRoleId] = useState("");
  const [universityRoleName, setUniversityRoleName] = useState("");
  const [requestSubmissionId, setRequestSubmissionId] = useState("");
  const [representativeCode, setRepresentativeCode] = useState("");
  const [reApplicationCode, setReApplicationCode] = useState("");
  const [representativeName, setRepresentativeName] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [departmentList, setDepartmentList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [representativeList, setRepresentativeList] = useState([]);
  const [noData, setNoData] = useState("");
  const [nullData, setNullData] = useState("");
  const [existingAffiliations, setExistingAffiliations] = useState([]);
  const routes = [
    {
      name: `${lang("Menu.home")}`,
      path: "/",
    },
    {
      name: `${lang("Menu.personCustomer")}`,
      path: "/personCustomer",
    },
    {
      name: `${lang("personDetails.personCustomerChangeRequest")}`,
      path: "",
    },
  ];

  useEffect(() => {
    async function fetchAffiliationData() {
      try {
        document.body.classList.add("sidebar-open");
        goBack();
        let id;
        let affiliationId;
        let personId;
        let path;
        let urlPath;
        let pathname = window.location.pathname;
        path = unescape(pathname).split("/")[1];
        setPath(path);
        let url = window.location.href;
    if (
      path === "affiliationChange" ||
      path === "affiliationRetirement" ||
      path === "newAffiliationRequest"
    ) {
      urlPath = unescape(url).split("?personId=")[1];
      personId = urlPath.split("&");
      id = personId[0];
      setPersonId(id);
      affiliationId = unescape(url).split("&affiliationId=")[1];
      setAffiliationId(affiliationId);
    } else if (
      path === "affiliationRequestEdit" ||
      path === "affiliationRequestResubmit"
    ) {
      id = unescape(url).split("?requestId=")[1];
    }
    const department = sessionStorage.getItem("Department");
    const role = sessionStorage.getItem("Role");
    setDepartmentList(JSON.parse(department));
    setRoleList(JSON.parse(role));
    if (path === "affiliationChange") {
      setSubmissionType("Change");
    } else if (path === "affiliationRetirement") {
      setSubmissionType("Retire");
    } else {
      setSubmissionType("New");
    }
    if (path === "affiliationChange" || path === "affiliationRetirement") {
      let body = {
        personId: id,
        affiliationId: affiliationId,
      };
      await props.getAffiliationDetails(body).then((res) => {
        if (res.maintenanceWindowFlag) {
          setMaintenance(true);
        }
        setIsLoading(false);
        let {
          unifiedCustomerCode,
          legacyUnifiedCustomerCode,
          customerType,
          facilityNameKanjiLocal,
          customerAffiliations,
          remarks,
        } = res;
        setUnifiedCustomerCode(unifiedCustomerCode ? unifiedCustomerCode : "");
        setLegacyUnifiedCustomerCode(
          legacyUnifiedCustomerCode ? legacyUnifiedCustomerCode : ""
        );
        setCustomerTypeId(
          customerType && customerType[0].custTypeID
            ? customerType[0].custTypeID
            : ""
        );
        setCustomerTypeName(
          customerType && customerType[0].customerTypeNameLocal
            ? customerType[0].customerTypeNameLocal
            : ""
        );
        setKanjiFacilityName(
          facilityNameKanjiLocal ? facilityNameKanjiLocal : ""
        );
        setRemarks(remarks ? remarks : "");
        setAffiliatedOrgId(
          customerAffiliations &&
            customerAffiliations.affiliated_organization_customer
        );
        setRepresentativeCode(
          customerAffiliations &&
            customerAffiliations.affiliated_organization_customer_unified_customer_code
            ? customerAffiliations.affiliated_organization_customer_unified_customer_code
            : ""
        );
        setRepresentativeName(
          customerAffiliations &&
            customerAffiliations.affiliated_organization_customer_name
            ? customerAffiliations.affiliated_organization_customer_name
            : ""
        );
        setDepartmentId(
          customerAffiliations && customerAffiliations.affiliated_department_id
            ? customerAffiliations.affiliated_department_id
            : ""
        );
        setDepartmentName(
          customerAffiliations && customerAffiliations.affiliated_department
            ? customerAffiliations.affiliated_department
            : ""
        );
        setRoleId(
          customerAffiliations && customerAffiliations.job_title_id
            ? customerAffiliations.job_title_id
            : ""
        );
        setRoleName(
          customerAffiliations && customerAffiliations.job_title
            ? customerAffiliations.job_title
            : ""
        );
        setUniversityRoleName(
          customerAffiliations && customerAffiliations.university_job_title
            ? customerAffiliations.university_job_title
            : ""
        );
        setUniversityRoleId(
          customerAffiliations && customerAffiliations.university_job_title_id
            ? customerAffiliations.university_job_title_id
            : ""
        );
        customerAffiliations.hospital_owner_flag === null &&
          setHospitalStatus(0);
        customerAffiliations.hospital_owner_flag === "0" &&
          setHospitalStatus(0);
        customerAffiliations.hospital_owner_flag === "1" &&
          setHospitalStatus(1);
      });
    } else if (path === "newAffiliationRequest") {
      await props.getPersonCustomerDetails(id).then((res) => {
        if(res.maintenanceWindowFlag){
          setMaintenance(true);
        }
        setIsLoading(false);
        let {
          perCustID,
          unifiedCustomerCode,
          legacyUnifiedCustomerCode,
          customerType,
          facilityNameKanjiLocal,
        } = res;

        setPersonId(perCustID);
        setUnifiedCustomerCode(unifiedCustomerCode ? unifiedCustomerCode : "");
        setLegacyUnifiedCustomerCode(
          legacyUnifiedCustomerCode ? legacyUnifiedCustomerCode : ""
        );
        setCustomerTypeId(
          customerType && customerType[0].custTypeID
            ? customerType[0].custTypeID
            : ""
        );
        setCustomerTypeName(
          customerType && customerType[0].customerTypeNameLocal
            ? customerType[0].customerTypeNameLocal
            : ""
        );
        setKanjiFacilityName(
          facilityNameKanjiLocal ? facilityNameKanjiLocal : ""
        );
      });
      await props.fetchPersonDetails(id).then((res) => {
        if (res.data.maintenanceWindowFlag) {
          setMaintenance(true);
        }
        let list = [];
        res &&
          res.data &&
          res.data.data &&
          res.data.data.affiliatedFacilities &&
          res.data.data.affiliatedFacilities.map((facility) => {
            list.push(facility.customerAffiliationOrganizationId);
          });
        setExistingAffiliations(list);
      });
    } else if (
      path === "affiliationRequestResubmit" ||
      path === "affiliationRequestEdit"
    ) {
      let body = {
        id: id,
      };
      await customerRequestDetails(body).then((res) => {
        if(res.maintenanceWindowFlag){
          setMaintenance(true);
        }
        setIsLoading(false);
        let {
          submission_id,
          submission_type,
          unified_customer_code,
          lagacy_unified_customer_code,
          customer_id,
          customer_type,
          name_kanji,
          per_customer_id,
          affiliated_organization_customer_code,
          affiliated_organization_customer_name,
          affiliated_department,
          role,
          university_role,
          hospital_owner,
          remarks,
          ultmarc_reception_code,
        } = res.data;
        setSubmissionId(
          submission_id && submission_id.value ? submission_id.value : ""
        );
        setCustomerId(
          customer_id && customer_id.value ? customer_id.value : ""
        );
        setSubmissionType(
          submission_type && submission_type.value ? submission_type.value : ""
        );
        setUnifiedCustomerCode(
          unified_customer_code && unified_customer_code.value
            ? unified_customer_code.value
            : ""
        );
        setLegacyUnifiedCustomerCode(
          lagacy_unified_customer_code && lagacy_unified_customer_code.value
            ? lagacy_unified_customer_code.value
            : ""
        );
        setCustomerTypeId(
          customer_type && customer_type.key ? customer_type.key : ""
        );
        setCustomerTypeName(
          customer_type && customer_type.value ? customer_type.value : ""
        );
        setKanjiFacilityName(
          name_kanji && name_kanji.value ? name_kanji.value : ""
        );
        setRemarks(remarks && remarks.value ? remarks.value : "");
        setPersonId(
          per_customer_id && per_customer_id.value ? per_customer_id.value : ""
        );
        setAffiliatedOrgId(
          affiliated_organization_customer_code &&
            affiliated_organization_customer_code.key
            ? affiliated_organization_customer_code.key
            : ""
        );
        setRepresentativeCode(
          affiliated_organization_customer_code &&
            affiliated_organization_customer_code.value
            ? affiliated_organization_customer_code.value
            : ""
        );
        setRepresentativeName(
          affiliated_organization_customer_name &&
            affiliated_organization_customer_name.value
            ? affiliated_organization_customer_name.value
            : ""
        );
        setDepartmentId(
          affiliated_department && affiliated_department.key
            ? affiliated_department.key
            : ""
        );
        setDepartmentName(
          affiliated_department && affiliated_department.value
            ? affiliated_department.value
            : ""
        );
        setRoleId(role && role.key ? role.key : "");
        setRoleName(role && role.value ? role.value : "");
        setUniversityRoleId(
          university_role && university_role.key ? university_role.key : ""
        );
        setUniversityRoleName(
          university_role && university_role.value ? university_role.value : ""
        );
        setHospitalStatus(
          hospital_owner &&
            hospital_owner.value &&
            hospital_owner.value === "Yes"
            ? 1
            : 0
        );
        path === "affiliationRequestResubmit" &&
          setReApplicationCode(
            ultmarc_reception_code &&
              ultmarc_reception_code.response_from_ultmarc
              ? ultmarc_reception_code.response_from_ultmarc
              : ""
          );
        path === "affiliationRequestEdit" &&
          setReApplicationCode(
            ultmarc_reception_code && ultmarc_reception_code.value
              ? ultmarc_reception_code.value
              : ""
          );
      });
    }
      } catch (error) {
        console.error("Error fetching affiliation data:", error);
        setIsLoading(false);
      }
    }
    
    fetchAffiliationData();
  }, []);

  useEffect(() => {
    setAffiliationNotice(
      props.language === "en"
        ? sessionStorage.getItem("en_affiliation_notice")
        : sessionStorage.getItem("jp_affiliation_notice")
    );
  }, [props.language]);

  
  /*** 
  @purpose : Go back
  @Parameter : {}
  **/
  const goBack = () => {
    setTimeout(() => {
      window.history.forward();
    }, 0);
  };

  /*** 
  @purpose : Close modal
  @Parameter : {}
  **/
  const handleClose = () => setShow(false);

  /*** 
  @purpose : Handle employee search
  @Parameter : {}
  **/
  const handleEmployeeSearch = () => {
    setActiveEmployeeSearch("esearch-box lg-box active");
  };

  /*** 
  @purpose : Close employee search
  @Parameter : {}
  **/
  const closeEmployeeSearch = () => {
    setActiveEmployeeSearch("esearch-box lg-box");
  };

  /*** 
  @purpose : Go to next step
  @Parameter : {}
  **/
  const next = () => {
    if (validateForm()) {
      setCurrent(current + 1);
    }
  };

  /*** 
  @purpose : Go to previous step
  @Parameter : {}
  **/
  const prev = () => {
    setCurrent(current - 1);
  };

  /*** 
  @purpose : Handle department change
  @Parameter : {value}
  **/
  const handleDepartmentChange = (value) => {
    if (value) {
      setDepartmentId(value.value);
      setDepartmentName(value.label);
    } else {
      setDepartmentId("");
      setDepartmentName("");
    }
  };

  /*** 
  @purpose : Handle role change
  @Parameter : {value}
  **/
  const handleRoleChange = (value) => {
    if (value) {
      setRoleId(value.value);
      setRoleName(value.label);
    } else {
      setRoleId("");
      setRoleName("");
    }
  };

  /*** 
  @purpose : Handle university role change
  @Parameter : {value}
  **/
  const handleUniversityRoleChange = (value) => {
    if (value) {
      setUniversityRoleId(value.value);
      setUniversityRoleName(value.label);
    } else {
      setUniversityRoleId("");
      setUniversityRoleName("");
    }
  };

  const handleRepresentativeCode = (item) => {
    /* setRepresentativeCode(item.legacyUnifiedCustomerCode);   /* SAKAMOTO: AHDD-5861 Ultmarc code change */
    setRepresentativeCode(item.unifiedCustomerCode);            /* SAKAMOTO: AHDD-5861 Ultmarc code change */
    setRepresentativeName(item.facilityName);
    setAffiliatedOrgId(item.orgCustID);
  };

  /*** 
  @purpose : Validate customer form
  @Parameter : {}
  **/
  const validateCustomerForm = () => {
    let isFormValid = true;
    let pattern = new RegExp(/[<(.|\n*?)>]/);
    let kanaRegex = new RegExp(/^[ｦ-ﾟ -~]+$/);
    let errors = {
      kanjiCustomerName: "",
      kanaCustomerName: "",
    };

    if (kanjiCustomerName && pattern.test(kanjiCustomerName))
      errors.kanjiCustomerName = "errorMessages.VALID_KANJI_CUSTOMER_NAME";

    if (kanaCustomerName && kanaRegex.test(kanaCustomerName) === false)
      errors.kanaCustomerName = "errorMessages.VALID_KANA_CUSTOMER_NAME";

    if (errors.kanjiCustomerName !== "" || errors.kanaCustomerName !== "") {
      isFormValid = false;
    } else {
      isFormValid = true;
    }
    setCustomerErrors(errors);

    return isFormValid;
  };

  /*** 
  @purpose : Validate person attribute change form
  @Parameter : {}
  **/
  const validateForm = () => {
    let isFormValid = true;
    let pattern = new RegExp(/[<.|\n*?>]/);
    let errors = {
      representativeCode: "",
      remarks: "",
    };

    if (representativeCode === "")
      errors.representativeCode =
        "errorMessages.PROVIDE_AFFILIATED_CUSTOMER_CODE";

    if (remarks && pattern.test(remarks))
      errors.remarks = "errorMessages.VALID_REMARKS";

    if (path === "newAffiliationRequest" || submissionType === "New") {
      if (errors.representativeCode !== "" || errors.remarks !== "") {
        isFormValid = false;
      } else {
        isFormValid = true;
      }
    } else {
      if (errors.remarks !== "") {
        isFormValid = false;
      } else {
        isFormValid = true;
      }
    }

    if (errors.representativeCode !== "" || errors.remarks !== "") {
      isFormValid = false;
    } else {
      isFormValid = true;
    }
    setErrors(errors);

    return isFormValid;
  };

  /*** 
  @purpose : Get representative list
  @Parameter : {}
  **/
  const getRepresentativeList = async () => {
    if (validateCustomerForm()) {
      setIsOrgLoading(true);
      let body = {
        unifiedCustomerCode: orgUnifiedCustomerCode,
        customerNameLocal: kanjiCustomerName,
        customerNameLocalKana: kanaCustomerName,
        isCustomerDCRFilter: true
      };
      await getOrganizationInquiryList(body).then((response) => {
        setIsOrgLoading(false);
        if (response.data.length === 0) {
          setRepresentativeList([]);
          setNoData(true);
        } else {
          let list = [];
          if (path === "newAffiliationRequest") {
            response.data.map((item) => {
              existingAffiliations.includes(item.orgCustID) === false &&
                list.push(item);
            });
            response.data.length > 0 && list.length === 0
              ? setNullData(true)
              : setNullData(false);
            setRepresentativeList(list);
          } else {
            setRepresentativeList(response.data);
            setNoData(false);
          }
        }
      });
    }
  };

  /*** 
  @purpose : Affiliation change
  @Parameter : {}
  **/
  const affiliationChange = async () => {
    setLoading(true);
    if (path === "affiliationChange") {
      let body = {
        perCustID: personId,
        medicalSpecialityID: affiliationId,
        orgCustID: affiliatedOrgId,
        affiliated_organization_customer: representativeCode,
        affiliated_department: departmentId,
        role: roleId,
        university_role: universityRoleId,
        hospital_owner: hospitalStatus,
        remarks: remarks,
      };
      await affiliationAttributeChange(body).then((response) => {
        setLoading(false);
        if (response.success === true) {
          setRequestSubmissionId(response.id);
          setCurrent(current + 1);
        } else if (response.success === false) {
          setLoading(false);
          setShow(true);
        }
      });
    } else if (path === "newAffiliationRequest") {
      let body = {
        perCustID: personId,
        unified_customer_code: unifiedCustomerCode,
        customer_type: customerTypeId,
        orgCustID: affiliatedOrgId,
        affiliated_organization_customer: representativeCode,
        affiliated_department: departmentId,
        role: roleId,
        university_role: universityRoleId,
        hospital_owner: hospitalStatus,
        remarks: remarks,
      };

      await addAffiliation(body).then((response) => {
        if (response.success === true) {
          setLoading(false);
          setRequestSubmissionId(response.id);
          setCurrent(current + 1);
        } else if (response.success === false) {
          if(response.message.includes("CustomerAffiliation already exists")){
            setAlreday(true)
          }
          setLoading(false);
          setShow(true);
        }
      });
    } else if (path === "affiliationRetirement") {
      let body = {
        perCustID: personId,
        affiliationID: affiliationId,
        remarks: remarks,
      };
      await deleteAffiliation(body).then((response) => {
        if (response.success === true) {
          setLoading(false);
          setRequestSubmissionId(response.id);
          setCurrent(current + 1);
        } else if (response.success === false) {
          setLoading(false);
          setShow(true);
        }
      });
    } else if (path === "affiliationRequestResubmit") {
      let body = {
        submission_type: submissionType,
        submission_data: "customer_affiliation",
        submission_id: submissionId,
        customer_id: customerId,
        remarks: remarks,
        perCustID: personId,
        unified_customer_code: unifiedCustomerCode,
        customer_name_kanji: kanjiFacilityName,
        customer_type: customerTypeId,
        orgCustID: affiliatedOrgId,
        affiliated_organization_customer: representativeCode,
        affiliated_department: departmentId,
        role: roleId,
        university_role: universityRoleId,
        hospital_owner: hospitalStatus,
        reapplication_acceptance_code: reApplicationCode,
      };
      await resubmitChangeRequest(body).then((response) => {
        if (response.success === true) {
          setLoading(false);
          setRequestSubmissionId(response.id);
          setCurrent(current + 1);
        } else if (response.success === false) {
          setLoading(false);
          setShow(true);
        }
      });
    } else if (path === "affiliationRequestEdit") {
      let body = {
        submission_type: submissionType,
        submission_data: "customer_affiliation",
        submission_id: submissionId,
        customer_id: customerId,
        remarks: remarks,
        perCustID: personId,
        unified_customer_code: unifiedCustomerCode,
        customer_name_kanji: kanjiFacilityName,
        customer_type: customerTypeId,
        orgCustID: affiliatedOrgId,
        affiliated_organization_customer: representativeCode,
        affiliated_department: departmentId,
        role: roleId,
        university_role: universityRoleId,
        hospital_owner: hospitalStatus,
        reapplication_acceptance_code: reApplicationCode,
      };
      await editChangeRequest(body).then((response) => {
        if (response.success === true) {
          setLoading(false);
          setRequestSubmissionId(response.id);
          setCurrent(current + 1);
        } else if (response.success === false) {
          setLoading(false);
          setShow(true);
        }
      });
    }
  };

  /*** 
  @purpose : Change route
  @Parameter : {e, page}
  **/
  const changeRoute = (e, page) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    navigate(page);
  };

  const steps = [
    {
      title: `${lang("organizationDetails.custNewChangeRequest")}`,
      content: (
        <React.Fragment>
          <div className="submission-box card shadow-card">
            <div className="card-body">
              <div className="sb-row">
                <div className="sb-label">
                  {lang("customerRequestStatus.submissionType")}
                </div>
                <div className="sb-content">
                  <a href="#">{submissionType}</a>
                </div>
              </div>
              <div className="sb-row">
                <div className="sb-label">
                  {lang("customerRequestStatus.submissionData")}
                </div>
                <div className="sb-content">
                  <a href="#">{lang("dailySellout.affiliation")}</a>
                </div>
              </div>
            </div>
          </div>
          <div className="warning-box card">
            <div className="card-body">
              {/* <div className="warning-icon">
                <img src="images/warning.svg" alt="warning" />
              </div> */}
              {/* <h4>{lang("organizationDetails.noticeLabel")}</h4> */}
              <p
                className="notice"
                dangerouslySetInnerHTML={{ __html: affiliationNotice }}
              />
            </div>
          </div>
          <div className="card shadow-card">
            <div className="card-header">
              <h4>{lang("organizationDetails.custNewChangeRequest")}</h4>
            </div>
            <div className="card-body">
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("organizationDetails.submissionID")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      readOnly
                      value={submissionId ? submissionId : ""}
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.unifiedCustomerCode")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={
                        /* legacyUnifiedCustomerCode    /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                        /*  ? legacyUnifiedCustomerCode /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                        unifiedCustomerCode             /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                          ? unifiedCustomerCode         /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                          : ""
                      }
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.customerType")}
                    <span className="danger">*</span>
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={customerTypeName ? customerTypeName : ""}
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("PersonMenu.kanjiName")}
                    <span className="danger">*</span>
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      maxLength="100"
                      value={kanjiFacilityName ? kanjiFacilityName : ""}
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("OrganizationMenu.affiliatedCode")}
                    <span className="danger">*</span>
                  </label>
                </div>
                <div className="custom-9">
                  <div className="mrs-main">
                    <div className="mrs-box">
                      <label className="select-mrs">{representativeName}</label>
                      {path === "newAffiliationRequest" && (
                        <div>
                          {representativeCode && (
                            <button
                              className="cancel"
                              onClick={() => {
                                setRepresentativeCode("");
                                setRepresentativeName("");
                                setAffiliatedOrgId("");
                              }}
                            >
                              X
                            </button>
                          )}
                          <button
                            className="btn btn-primary"
                            onClick={handleEmployeeSearch}
                          >
                            {lang("Buttons.select")}
                          </button>
                        </div>
                      )}
                      {path === "affiliationChange" && (
                        <button
                          className="btn btn-primary"
                          onClick={handleEmployeeSearch}
                          disabled
                        >
                          {lang("Buttons.select")}
                        </button>
                      )}
                      {path === "affiliationRetirement" && (
                        <button
                          className="btn btn-primary"
                          onClick={handleEmployeeSearch}
                          disabled
                        >
                          {lang("Buttons.select")}
                        </button>
                      )}
                      {path === "affiliationRequestEdit" &&
                        submissionType === "New" && (
                          <div>
                            {representativeCode && (
                              <button
                                className="cancel"
                                onClick={() => {
                                  setRepresentativeCode("");
                                  setRepresentativeName("");
                                  setAffiliatedOrgId("");
                                }}
                              >
                                X
                              </button>
                            )}
                            <button
                              className="btn btn-primary"
                              onClick={handleEmployeeSearch}
                            >
                              {lang("Buttons.select")}
                            </button>
                          </div>
                        )}
                      {path === "affiliationRequestResubmit" &&
                        submissionType === "New" && (
                          <div>
                            {representativeCode && (
                              <button
                                className="cancel"
                                onClick={() => {
                                  setRepresentativeCode("");
                                  setRepresentativeName("");
                                  setAffiliatedOrgId("");
                                }}
                              >
                                X
                              </button>
                            )}
                            <button
                              className="btn btn-primary"
                              onClick={handleEmployeeSearch}
                            >
                              {lang("Buttons.select")}
                            </button>
                          </div>
                        )}
                      {path === "affiliationRequestEdit" &&
                        submissionType === "Change" && (
                          <div>
                            {representativeCode && (
                              <button
                                className="cancel"
                                onClick={() => {
                                  setRepresentativeCode("");
                                  setRepresentativeName("");
                                  setAffiliatedOrgId("");
                                }}
                                disabled
                              >
                                X
                              </button>
                            )}
                            <button
                              className="btn btn-primary"
                              onClick={handleEmployeeSearch}
                              disabled
                            >
                              {lang("Buttons.select")}
                            </button>
                          </div>
                        )}
                      {path === "affiliationRequestResubmit" &&
                        submissionType === "Change" && (
                          <div>
                            {representativeCode && (
                              <button
                                className="cancel"
                                onClick={() => {
                                  setRepresentativeCode("");
                                  setRepresentativeName("");
                                  setAffiliatedOrgId("");
                                }}
                                disabled
                              >
                                X
                              </button>
                            )}
                            <button
                              className="btn btn-primary"
                              onClick={handleEmployeeSearch}
                              disabled
                            >
                              {lang("Buttons.select")}
                            </button>
                          </div>
                        )}
                      {path === "affiliationRequestResubmit" &&
                        submissionType === "Delete" && (
                          <button
                            className="btn btn-primary"
                            onClick={handleEmployeeSearch}
                            disabled
                          >
                            {lang("Buttons.select")}
                          </button>
                        )}
                      {path === "affiliationRequestResubmit" &&
                        submissionType === "Retirement " && (
                          <button
                            className="btn btn-primary"
                            onClick={handleEmployeeSearch}
                            disabled
                          >
                            {lang("Buttons.select")}
                          </button>
                        )}
                      {path === "affiliationRequestEdit" &&
                        submissionType === "Delete" && (
                          <button
                            className="btn btn-primary"
                            onClick={handleEmployeeSearch}
                            disabled
                          >
                            {lang("Buttons.select")}
                          </button>
                        )}
                      {path === "affiliationRequestEdit" &&
                        submissionType === "Retirement " && (
                          <button
                            className="btn btn-primary"
                            onClick={handleEmployeeSearch}
                            disabled
                          >
                            {lang("Buttons.select")}
                          </button>
                        )}
                    </div>
                    <div className={activeEmployeeSearch}>
                      <div className="row">
                        <div className="col-md-9">
                          <div className="form-group inline-input lg">
                            <label>
                              {lang("organizationDetails.unifiedCustomerCode")}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={orgUnifiedCustomerCode}
                              onChange={(e) =>
                                setOrgUnifiedCustomerCode(e.target.value)
                              }
                            />
                          </div>
                          <div className="form-group inline-input lg">
                            <label>
                              {lang("organizationDetails.kanjiCustomerName")}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={kanjiCustomerName}
                              maxLength="100"
                              onChange={(e) =>
                                setKanjiCustomerName(e.target.value)
                              }
                            />
                            {customerErrors.kanjiCustomerName && (
                              <p className="error-text">
                                {lang(`${customerErrors.kanjiCustomerName}`)}
                              </p>
                            )}
                          </div>
                          <div className="form-group inline-input lg">
                            <label>
                              {lang("organizationDetails.kanaCustomerName")}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={kanaCustomerName}
                              maxLength="100"
                              onChange={(e) =>
                                setKanaCustomerName(e.target.value)
                              }
                            />
                            {customerErrors.kanaCustomerName && (
                              <p className="error-text">
                                {lang(`${customerErrors.kanaCustomerName}`)}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-12 mb-4">
                          <button
                            className="btn btn-primary"
                            onClick={getRepresentativeList}
                            disabled={isOrgLoading}
                          >
                            {lang("Buttons.apply")}
                          </button>
                        </div>
                      </div>
                      {isOrgLoading && <Spinner animation="border" />}
                      {representativeList.length > 0 && (
                        <>
                          <p className="record-total">
                            {lang(
                              "territoryDefinitionMaintenance.totalRecords"
                            )}{" "}
                            - {representativeList.length}
                          </p>
                          <div className="table-responsive esearch-table">
                            <table className="table" aria-describedby="table">
                              <thead>
                                <tr>
                                  <th scope="col"></th>
                                  <th scope="col">
                                    <div className="cursor-pointer">
                                      {lang(
                                        "organizationDetails.unifiedCustomerCode"
                                      )}
                                      <em className="bx bxs-sort-alt"></em>
                                    </div>
                                  </th>
                                  <th scope="col">
                                    <div className="cursor-pointer">
                                      {lang(
                                        "organizationDetails.kanjiCustomerName"
                                      )}
                                      <em className="bx bxs-sort-alt"></em>
                                    </div>
                                  </th>
                                  <th scope="col">
                                    <div className="cursor-pointer">
                                      {lang("OrganizationMenu.customerType")}
                                      <em className="bx bxs-sort-alt"></em>
                                    </div>
                                  </th>
                                </tr>
                              </thead>
                              {path === "newAffiliationRequest" && (
                                <tbody>
                                  {representativeList &&
                                    representativeList.map((item,index) => {
                                      return (
                                        <tr key={index}>
                                          <td>
                                            <button
                                              className="btn btn-primary"
                                              onClick={() =>
                                                handleRepresentativeCode(item)
                                              }
                                            >
                                              {lang("Buttons.select")}
                                            </button>
                                          </td>
                                          <td>
                                            {/* item.legacyUnifiedCustomerCode    /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
                                            {item.unifiedCustomerCode             /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
                                          </td>
                                          <td>{item.facilityName}</td>
                                          <td>{item.customerTypeName}</td>
                                        </tr>
                                      );
                                    })}
                                </tbody>
                              )}
                              {path !== "newAffiliationRequest" && (
                                <tbody>
                                  {representativeList &&
                                    representativeList.map((item,index) => {
                                      return (
                                        <tr key={index}>
                                          <td>
                                            <button
                                              className="btn btn-primary"
                                              onClick={() =>
                                                handleRepresentativeCode(item)
                                              }
                                            >
                                              {lang("Buttons.select")}
                                            </button>
                                          </td>
                                          <td>{item.customerCode}</td>
                                          <td>{item.customerTypeName}</td>
                                          <td>{item.facilityName}</td>
                                        </tr>
                                      );
                                    })}
                                </tbody>
                              )}
                            </table>
                          </div>
                        </>
                      )}
                      {noData && (
                        <div className="noData">
                          {lang("errorMessages.NO_DATA")}
                        </div>
                      )}
                      {representativeCode.length === 0 && nullData && (
                        <p className="error-text">
                          {lang("errorMessages.AFFILIATION_EXISTS")}
                        </p>
                      )}
                      <div className="mt-2 text-right">
                        <button
                          className="btn btn-primary"
                          onClick={closeEmployeeSearch}
                        >
                          {lang("Buttons.close")}
                        </button>
                      </div>
                    </div>
                  </div>
                  {errors.representativeCode && (
                    <p className="error-text">
                      {lang(`${errors.representativeCode}`)}
                    </p>
                  )}
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.affiliatedDepartment")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    {path === "newAffiliationRequest" && (
                      <Select
                        className="ant-select"
                        options={departmentList}
                        onChange={handleDepartmentChange}
                        allowClear={departmentId ? true : false}
                        placeholder={departmentName ? departmentName : ""}
                        labelInValue
                        showSearch
                        optionFilterProp="label"
                      />
                    )}
                    {path === "affiliationChange" && (
                      <Select
                        className="ant-select"
                        options={departmentList}
                        onChange={handleDepartmentChange}
                        placeholder={departmentName ? departmentName : ""}
                        allowClear={departmentId ? true : false}
                        value={departmentId ? { value: departmentId, label: departmentName } : undefined}
                        labelInValue
                        showSearch={departmentList && departmentList.length > 0 ? true : false}
                        optionFilterProp="label"
                      />
                    )}
                    {path === "affiliationRetirement" && (
                      <Select
                        className="ant-select"
                        options={departmentList}
                        onChange={handleDepartmentChange}
                        disabled={true}
                        allowClear={departmentId ? true : false}
                        value={departmentId ? { value: departmentId, label: departmentName } : undefined}
                        placeholder={departmentName ? departmentName : ""}
                        labelInValue
                        showSearch={departmentList && departmentList.length > 0 ? true : false}
                        optionFilterProp="label"
                      />
                    )}
                    {path === "affiliationRequestResubmit" &&
                      submissionType === "New" && (
                        <Select
                          className="ant-select"
                          options={departmentList}
                          onChange={handleDepartmentChange}
                          allowClear={departmentId ? true : false}
                          value={departmentId ? { value: departmentId, label: departmentName } : undefined}
                          placeholder={departmentName ? departmentName : ""}
                          labelInValue
                          showSearch={departmentList && departmentList.length > 0 ? true : false}
                          optionFilterProp="label"
                        />
                      )}
                    {path === "affiliationRequestEdit" &&
                      submissionType === "New" && (
                        <Select
                          className="ant-select"
                          options={departmentList}
                          onChange={handleDepartmentChange}
                          allowClear={departmentId ? true : false}
                          value={departmentId ? { value: departmentId, label: departmentName } : undefined}
                          placeholder={departmentName ? departmentName : ""}
                          labelInValue
                          showSearch={departmentList && departmentList.length > 0 ? true : false}
                          optionFilterProp="label"
                        />
                      )}
                    {path === "affiliationRequestResubmit" &&
                      submissionType === "Change" && (
                        <Select
                          className="ant-select"
                          options={departmentList}
                          onChange={handleDepartmentChange}
                          allowClear={departmentId ? true : false}
                          value={departmentId ? { value: departmentId, label: departmentName } : undefined}
                          placeholder={departmentName ? departmentName : ""}
                          labelInValue
                          showSearch={departmentList && departmentList.length > 0 ? true : false}
                          optionFilterProp="label"
                        />
                      )}
                    {path === "affiliationRequestEdit" &&
                      submissionType === "Change" && (
                        <Select
                          className="ant-select"
                          options={departmentList}
                          onChange={handleDepartmentChange}
                          allowClear={departmentId ? true : false}
                          value={departmentId ? { value: departmentId, label: departmentName } : undefined}
                          placeholder={departmentName ? departmentName : ""}
                          labelInValue
                          showSearch={departmentList && departmentList.length > 0 ? true : false}
                          optionFilterProp="label"
                        />
                      )}
                    {path === "affiliationRequestResubmit" &&
                      submissionType === "Delete" && (
                        <Select
                          className="ant-select"
                          options={departmentList}
                          onChange={handleDepartmentChange}
                          allowClear={departmentId ? true : false}
                          disabled={true}
                          value={departmentId ? { value: departmentId, label: departmentName } : undefined}
                          placeholder={departmentName ? departmentName : ""}
                          labelInValue
                          showSearch={departmentList && departmentList.length > 0 ? true : false}
                          optionFilterProp="label"
                        />
                      )}
                    {path === "affiliationRequestResubmit" &&
                      submissionType === "Retirement " && (
                        <Select
                          className="ant-select"
                          options={departmentList}
                          onChange={handleDepartmentChange}
                          allowClear={departmentId ? true : false}
                          disabled={true}
                          value={departmentId ? { value: departmentId, label: departmentName } : undefined}
                          placeholder={departmentName ? departmentName : ""}
                          labelInValue
                          showSearch={departmentList && departmentList.length > 0 ? true : false}
                          optionFilterProp="label"
                        />
                      )}
                    {path === "affiliationRequestEdit" &&
                      submissionType === "Delete" && (
                        <Select
                          className="ant-select"
                          options={departmentList}
                          onChange={handleDepartmentChange}
                          disabled={true}
                          allowClear={departmentId ? true : false}
                          value={departmentId ? { value: departmentId, label: departmentName } : undefined}
                          placeholder={departmentName ? departmentName : ""}
                          labelInValue
                          showSearch={departmentList && departmentList.length > 0 ? true : false}
                          optionFilterProp="label"
                        />
                      )}
                    {path === "affiliationRequestEdit" &&
                      submissionType === "Retirement " && (
                        <Select
                          className="ant-select"
                          options={departmentList}
                          onChange={handleDepartmentChange}
                          disabled={true}
                          allowClear={departmentId ? true : false}
                          value={departmentId ? { value: departmentId, label: departmentName } : undefined}
                          placeholder={departmentName ? departmentName : ""}
                          labelInValue
                          showSearch={departmentList && departmentList.length > 0 ? true : false}
                          optionFilterProp="label"
                        />
                      )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("organizationDetails.role")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    {path === "newAffiliationRequest" && (
                      <Select
                        className="ant-select"
                        options={roleList}
                        allowClear={roleId ? true : false}
                        value={roleId ? { value: roleId, label: roleName } : undefined}
                        onChange={handleRoleChange}
                        labelInValue
                        showSearch={roleList && roleList.length > 0 ? true : false}
                        optionFilterProp="label"
                      />
                    )}
                    {path === "affiliationChange" && (
                      <Select
                        className="ant-select"
                        options={roleList}
                        onChange={handleRoleChange}
                        allowClear={roleId ? true : false}
                        value={roleId ? { value: roleId, label: roleName } : undefined}
                        labelInValue
                        showSearch={roleList && roleList.length > 0 ? true : false}
                        optionFilterProp="label"
                      />
                    )}
                    {path === "affiliationRetirement" && (
                      <Select
                        className="ant-select"
                        disabled={true}
                        options={roleList}
                        allowClear={roleId ? true : false}
                        onChange={handleRoleChange}
                        value={roleId ? { value: roleId, label: roleName } : undefined}
                        labelInValue
                        showSearch={roleList && roleList.length > 0 ? true : false}
                        optionFilterProp="label"
                      />
                    )}
                    {path === "affiliationRequestResubmit" &&
                      submissionType === "New" && (
                        <Select
                          className="ant-select"
                          options={roleList}
                          allowClear={roleId ? true : false}
                          onChange={handleRoleChange}
                          value={roleId ? { value: roleId, label: roleName } : undefined}
                          labelInValue
                          showSearch={roleList && roleList.length > 0 ? true : false}
                          optionFilterProp="label"
                        />
                      )}
                    {path === "affiliationRequestEdit" &&
                      submissionType === "New" && (
                        <Select
                          className="ant-select"
                          options={roleList}
                          allowClear={roleId ? true : false}
                          onChange={handleRoleChange}
                          value={roleId ? { value: roleId, label: roleName } : undefined}
                          labelInValue
                          showSearch={roleList && roleList.length > 0 ? true : false}
                          optionFilterProp="label"
                        />
                      )}
                    {path === "affiliationRequestResubmit" &&
                      submissionType === "Change" && (
                        <Select
                          className="ant-select"
                          options={roleList}
                          allowClear={roleId ? true : false}
                          onChange={handleRoleChange}
                          value={roleId ? { value: roleId, label: roleName } : undefined}
                          labelInValue
                          showSearch={roleList && roleList.length > 0 ? true : false}
                          optionFilterProp="label"
                        />
                      )}
                    {path === "affiliationRequestEdit" &&
                      submissionType === "Change" && (
                        <Select
                          className="ant-select"
                          options={roleList}
                          allowClear={roleId ? true : false}
                          onChange={handleRoleChange}
                          value={roleId ? { value: roleId, label: roleName } : undefined}
                          labelInValue
                          showSearch={roleList && roleList.length > 0 ? true : false}
                          optionFilterProp="label"
                        />
                      )}
                    {path === "affiliationRequestResubmit" &&
                      submissionType === "Delete" && (
                        <Select
                          className="ant-select"
                          disabled={true}
                          options={roleList}
                          allowClear={roleId ? true : false}
                          onChange={handleRoleChange}
                          value={roleId ? { value: roleId, label: roleName } : undefined}
                          labelInValue
                          showSearch={roleList && roleList.length > 0 ? true : false}
                          optionFilterProp="label"
                        />
                      )}
                    {path === "affiliationRequestResubmit" &&
                      submissionType === "Retirement " && (
                        <Select
                          className="ant-select"
                          disabled={true}
                          options={roleList}
                          allowClear={roleId ? true : false}
                          onChange={handleRoleChange}
                          value={roleId ? { value: roleId, label: roleName } : undefined}
                          labelInValue
                          showSearch={roleList && roleList.length > 0 ? true : false}
                          optionFilterProp="label"
                        />
                      )}
                    {path === "affiliationRequestEdit" &&
                      submissionType === "Delete" && (
                        <Select
                          className="ant-select"
                          disabled={true}
                          options={roleList}
                          allowClear={roleId ? true : false}
                          onChange={handleRoleChange}
                          value={roleId ? { value: roleId, label: roleName } : undefined}
                          labelInValue
                          showSearch={roleList && roleList.length > 0 ? true : false}
                          optionFilterProp="label"
                        />
                      )}
                    {path === "affiliationRequestEdit" &&
                      submissionType === "Retirement " && (
                        <Select
                          className="ant-select"
                          disabled={true}
                          options={roleList}
                          allowClear={roleId ? true : false}
                          onChange={handleRoleChange}
                          value={roleId ? { value: roleId, label: roleName } : undefined}
                          labelInValue
                          showSearch={roleList && roleList.length > 0 ? true : false}
                          optionFilterProp="label"
                        />
                      )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("organizationDetails.universityRole")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    {path === "newAffiliationRequest" && (
                      <Select
                        className="ant-select"
                        options={roleList}
                        allowClear={universityRoleId ? true : false}
                        value={universityRoleId ? {
                          value: universityRoleId,
                          label: universityRoleName,
                        } : undefined}
                        onChange={handleUniversityRoleChange}
                        labelInValue
                        showSearch={roleList && roleList.length > 0 ? true : false}
                        optionFilterProp="label"
                      />
                    )}
                    {path === "affiliationChange" && (
                      <Select
                        className="ant-select"
                        options={roleList}
                        allowClear={universityRoleId ? true : false}
                        value={universityRoleId ? {
                          value: universityRoleId,
                          label: universityRoleName,
                        } : undefined}
                        onChange={handleUniversityRoleChange}
                        placeholder={
                          universityRoleName ? universityRoleName : ""
                        }
                        labelInValue
                        showSearch={roleList && roleList.length > 0 ? true : false}
                        optionFilterProp="label"
                      />
                    )}
                    {path === "affiliationRetirement" && (
                      <Select
                        className="ant-select"
                        disabled={true}
                        options={roleList}
                        allowClear={universityRoleId ? true : false}
                        value={universityRoleId ? {
                          value: universityRoleId,
                          label: universityRoleName,
                        } : undefined}
                        onChange={handleUniversityRoleChange}
                        placeholder={
                          universityRoleName ? universityRoleName : ""
                        }
                        labelInValue
                        showSearch={roleList && roleList.length > 0 ? true : false}
                        optionFilterProp="label"
                      />
                    )}
                    {path === "affiliationRequestResubmit" &&
                      submissionType === "New" && (
                        <Select
                          className="ant-select"
                          options={roleList}
                          allowClear={universityRoleId ? true : false}
                          value={universityRoleId ? {
                            value: universityRoleId,
                            label: universityRoleName,
                          } : undefined}
                          onChange={handleUniversityRoleChange}
                          placeholder={
                            universityRoleName ? universityRoleName : ""
                          }
                          labelInValue
                          showSearch={roleList && roleList.length > 0 ? true : false}
                          optionFilterProp="label"
                        />
                      )}
                    {path === "affiliationRequestEdit" &&
                      submissionType === "New" && (
                        <Select
                          className="ant-select"
                          options={roleList}
                          allowClear={universityRoleId ? true : false}
                          value={universityRoleId ? {
                            value: universityRoleId,
                            label: universityRoleName,
                          } : undefined}
                          onChange={handleUniversityRoleChange}
                          placeholder={
                            universityRoleName ? universityRoleName : ""
                          }
                          labelInValue
                          showSearch={roleList && roleList.length > 0 ? true : false}
                          optionFilterProp="label"
                        />
                      )}
                    {path === "affiliationRequestResubmit" &&
                      submissionType === "Change" && (
                        <Select
                          className="ant-select"
                          options={roleList}
                          allowClear={universityRoleId ? true : false}
                          value={universityRoleId ? {
                            value: universityRoleId,
                            label: universityRoleName,
                          } : undefined}
                          onChange={handleUniversityRoleChange}
                          placeholder={
                            universityRoleName ? universityRoleName : ""
                          }
                          labelInValue
                          showSearch={roleList && roleList.length > 0 ? true : false}
                          optionFilterProp="label"
                        />
                      )}
                    {path === "affiliationRequestEdit" &&
                      submissionType === "Change" && (
                        <Select
                          className="ant-select"
                          options={roleList}
                          allowClear={universityRoleId ? true : false}
                          value={universityRoleId ? {
                            value: universityRoleId,
                            label: universityRoleName,
                          } : undefined}
                          onChange={handleUniversityRoleChange}
                          placeholder={
                            universityRoleName ? universityRoleName : ""
                          }
                          labelInValue
                          showSearch={roleList && roleList.length > 0 ? true : false}
                          optionFilterProp="label"
                        />
                      )}
                    {path === "affiliationRequestResubmit" &&
                      submissionType === "Delete" && (
                        <Select
                          className="ant-select"
                          disabled={true}
                          options={roleList}
                          allowClear={universityRoleId ? true : false}
                          value={universityRoleId ? {
                            value: universityRoleId,
                            label: universityRoleName,
                          } : undefined}
                          onChange={handleUniversityRoleChange}
                          placeholder={
                            universityRoleName ? universityRoleName : ""
                          }
                          labelInValue
                          showSearch={roleList && roleList.length > 0 ? true : false}
                          optionFilterProp="label"
                        />
                      )}
                    {path === "affiliationRequestResubmit" &&
                      submissionType === "Retirement " && (
                        <Select
                          className="ant-select"
                          disabled={true}
                          options={roleList}
                          allowClear={universityRoleId ? true : false}
                          value={universityRoleId ? {
                            value: universityRoleId,
                            label: universityRoleName,
                          } : undefined}
                          onChange={handleUniversityRoleChange}
                          placeholder={
                            universityRoleName ? universityRoleName : ""
                          }
                          labelInValue
                          showSearch={roleList && roleList.length > 0 ? true : false}
                          optionFilterProp="label"
                        />
                      )}
                    {path === "affiliationRequestEdit" &&
                      submissionType === "Delete" && (
                        <Select
                          className="ant-select"
                          disabled={true}
                          options={roleList}
                          allowClear={universityRoleId ? true : false}
                          value={universityRoleId ? {
                            value: universityRoleId,
                            label: universityRoleName,
                          } : undefined}
                          onChange={handleUniversityRoleChange}
                          placeholder={
                            universityRoleName ? universityRoleName : ""
                          }
                          labelInValue
                          showSearch={roleList && roleList.length > 0 ? true : false}
                          optionFilterProp="label"
                        />
                      )}
                    {path === "affiliationRequestEdit" &&
                      submissionType === "Retirement " && (
                        <Select
                          className="ant-select"
                          disabled={true}
                          options={roleList}
                          allowClear={universityRoleId ? true : false}
                          value={universityRoleId ? {
                            value: universityRoleId,
                            label: universityRoleName,
                          } : undefined}
                          onChange={handleUniversityRoleChange}
                          placeholder={
                            universityRoleName ? universityRoleName : ""
                          }
                          labelInValue
                          showSearch={roleList && roleList.length > 0 ? true : false}
                          optionFilterProp="label"
                        />
                      )}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield mt-2">
                <div className="custom-3">
                  <label>{lang("organizationDetails.hospitalOwner")}</label>
                </div>
                <div className="custom-9">
                  <div className="custom-checkbox mb-0">
                    {path === "newAffiliationRequest" && (
                      <input
                        type="checkbox"
                        id="owner2"
                        name="table-checkbox"
                        checked={hospitalStatus === 0 ? false : true}
                        onChange={(e) =>
                          setHospitalStatus(e.target.checked ? 1 : 0)
                        }
                      />
                    )}
                    {path === "affiliationChange" && (
                      <input
                        type="checkbox"
                        id="owner2"
                        name="table-checkbox"
                        checked={hospitalStatus === 0 ? false : true}
                        onChange={(e) =>
                          setHospitalStatus(e.target.checked ? 1 : 0)
                        }
                      />
                    )}
                    {path === "affiliationRetirement" && (
                      <input
                        type="checkbox"
                        id="owner2"
                        disabled
                        name="table-checkbox"
                        checked={hospitalStatus === 0 ? false : true}
                        onChange={(e) =>
                          setHospitalStatus(e.target.checked ? 1 : 0)
                        }
                      />
                    )}
                    {path === "affiliationRequestResubmit" &&
                      submissionType === "New" && (
                        <input
                          type="checkbox"
                          id="owner2"
                          name="table-checkbox"
                          checked={hospitalStatus === 0 ? false : true}
                          onChange={(e) =>
                            setHospitalStatus(e.target.checked ? 1 : 0)
                          }
                        />
                      )}
                    {path === "affiliationRequestEdit" &&
                      submissionType === "New" && (
                        <input
                          type="checkbox"
                          id="owner2"
                          name="table-checkbox"
                          checked={hospitalStatus === 0 ? false : true}
                          onChange={(e) =>
                            setHospitalStatus(e.target.checked ? 1 : 0)
                          }
                        />
                      )}
                    {path === "affiliationRequestResubmit" &&
                      submissionType === "Change" && (
                        <input
                          type="checkbox"
                          id="owner2"
                          name="table-checkbox"
                          checked={hospitalStatus === 0 ? false : true}
                          onChange={(e) =>
                            setHospitalStatus(e.target.checked ? 1 : 0)
                          }
                        />
                      )}
                    {path === "affiliationRequestEdit" &&
                      submissionType === "Change" && (
                        <input
                          type="checkbox"
                          id="owner2"
                          name="table-checkbox"
                          checked={hospitalStatus === 0 ? false : true}
                          onChange={(e) =>
                            setHospitalStatus(e.target.checked ? 1 : 0)
                          }
                        />
                      )}
                    {path === "affiliationRequestResubmit" &&
                      submissionType === "Delete" && (
                        <input
                          type="checkbox"
                          id="owner2"
                          disabled
                          name="table-checkbox"
                          checked={hospitalStatus === 0 ? false : true}
                          onChange={(e) =>
                            setHospitalStatus(e.target.checked ? 1 : 0)
                          }
                        />
                      )}
                    {path === "affiliationRequestResubmit" &&
                      submissionType === "Retirement " && (
                        <input
                          type="checkbox"
                          id="owner2"
                          disabled
                          name="table-checkbox"
                          checked={hospitalStatus === 0 ? false : true}
                          onChange={(e) =>
                            setHospitalStatus(e.target.checked ? 1 : 0)
                          }
                        />
                      )}
                    {path === "affiliationRequestEdit" &&
                      submissionType === "Delete" && (
                        <input
                          type="checkbox"
                          id="owner2"
                          disabled
                          name="table-checkbox"
                          checked={hospitalStatus === 0 ? false : true}
                          onChange={(e) =>
                            setHospitalStatus(e.target.checked ? 1 : 0)
                          }
                        />
                      )}
                    {path === "affiliationRequestEdit" &&
                      submissionType === "Retirement " && (
                        <input
                          type="checkbox"
                          id="owner2"
                          disabled
                          name="table-checkbox"
                          checked={hospitalStatus === 0 ? false : true}
                          onChange={(e) =>
                            setHospitalStatus(e.target.checked ? 1 : 0)
                          }
                        />
                      )}
                    <label className="mb-0" htmlFor="owner2"></label>
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label className="ultmarc-contact-note-label">
                    <UltmarcRemarkLabel />
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <textarea
                      className="form-control"
                      value={remarks ? remarks : ""}
                      maxLength="200"
                      onChange={(e) => setRemarks(e.target.value)}
                    ></textarea>
                    <p className="error-text">{errors.remarks}</p>
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.reapplicationAcceptanceCode")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={reApplicationCode}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ),
    },
    {
      title: `${lang("organizationDetails.confirmationLabel")}`,
      content: (
        <React.Fragment>
          <div className="card shadow-card">
            <div className="card-header">
              <h4>{lang("organizationDetails.confirmationLabel")}</h4>
            </div>
            <div className="card-body">
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("customerRequestStatus.submissionType")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">{submissionType}</div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("customerRequestStatus.submissionData")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {lang("dailySellout.affiliation")}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("organizationDetails.submissionID")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label">-</div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.unifiedCustomerCode")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {/* legacyUnifiedCustomerCode ? legacyUnifiedCustomerCode : ""  /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
                    {unifiedCustomerCode ? unifiedCustomerCode : ""                 /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.customerType")}
                    <span className="danger">*</span>
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {customerTypeName ? customerTypeName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("OrganizationMenu.kanjiFacilityName")}
                    <span className="danger">*</span>
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {kanjiFacilityName ? kanjiFacilityName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("OrganizationMenu.affiliatedName")}</label>
                  <span className="danger">*</span>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {representativeCode ? representativeName + "(" + representativeCode + ")" : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.affiliatedDepartment")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {departmentName ? departmentName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("organizationDetails.role")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {roleName ? roleName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("organizationDetails.universityRole")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {universityRoleName ? universityRoleName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("organizationDetails.hospitalOwner")}</label>
                </div>
                <div className="custom-9">
                  <div className="custom-checkbox">
                    <input
                      type="checkbox"
                      id="check1"
                      name="table-checkbox"
                      checked={hospitalStatus === 0 ? false : true}
                      disabled
                    />
                    <label className="mb-0" htmlFor="check1"></label>
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label className="ultmarc-contact-note-label">
                    <UltmarcRemarkLabel />
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {remarks ? remarks : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.reapplicationAcceptanceCode")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label">{reApplicationCode}</div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ),
    },
    {
      title: `${lang("organizationDetails.completedLabel")}`,
      content: (
        <React.Fragment>
          <div className="submission-box card shadow-card">
            <div className="card-header">
              <h4>{lang("organizationDetails.completedLabel")}</h4>
            </div>
            <div className="card-body">
              <p className="mb-3">
                {lang("errorMessages.REQUEST_SUBMITTED")}
                <span className="subm-title">
                  {lang("organizationDetails.submissionID")} :{" "}
                  {requestSubmissionId}
                </span>
              </p>
              <p className="mb-3">
                {lang("errorMessages.VIEW_SUBMISSION_STATUS")}
                <a
                  className="link"
                  onClick={(e) => {
                    changeRoute(e, "/customerRequestStatus");
                  }}
                >
                  {" "}
                  {lang("Menu.customerRequestStatus")}
                </a>
              </p>
            </div>
          </div>
        </React.Fragment>
      ),
    },
  ];

  return (
    <Home>
        {maintenance ? (
        <Maintenance />
      ) : (
      <>
      <Breadcrumb routes={routes} />
      {isLoading ? (
        <Spinner animation="border" />
      ) : (
        <>
          <Steps current={current}>
            {steps.map((item) => (
              <Step key={item.title} title={item.title} />
            ))}
          </Steps>
          <div className="steps-content horizon-form-lg">
            {steps[current].content}
          </div>
          <div className="steps-action">
            {loading && <Spinner animation="border" />}
            {current > 0 && current < 2 && (
              <Button
                style={{ margin: "0 12px" }}
                onClick={() => prev()}
                disabled={loading}
              >
                {lang("Buttons.previous")}
              </Button>
            )}
            {current < 2 && (
              <Button
                type="primary"
                disabled={loading}
                onClick={() => (current < 1 ? next() : affiliationChange())}
              >
                {current < 1
                  ? `${lang("Buttons.next")}`
                  : `${lang("Buttons.submit")}`}
              </Button>
            )}
          </div>
          <Modal
            size="md"
            className="withdraw-modal"
            show={show}
            onHide={handleClose}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div className="warning-msg">
                {alreday ? lang("errorMessages.REQUEST_NOT_SUBMITTED_US_EXISTED") : lang("errorMessages.REQUEST_NOT_SUBMITTED")}
              </div>
              <div className="buttons-group">
                <button className="btn btn-primary" onClick={handleClose}>
                  {lang("Buttons.ok")}
                </button>
              </div>
            </Modal.Body>
          </Modal>
        </>
      )}
      </>)}
    </Home>
  );
}

const mapStateToProps = (state) => {
  return {
    details: state.organizationCustomer.orgDetails,
    language: state.organizationCustomer.language,
  };
};

export default connect(mapStateToProps, {
  fetchPersonDetails,
  getPersonCustomerDetails,
  getAffiliationDetails,
})(AffiliationAttributeChange);
